import {WebsitesList} from './WebsitesList';
import {WebsitesCreate} from './websites-create/WebsitesCreate';
import {WebsitesEdit} from './websites-edit';
import blankRAViews from '../../components/BlankRAViews';

export default {
  ...blankRAViews,
  list: WebsitesList,
  create: WebsitesCreate,
  edit: WebsitesEdit,
};
